const playlistsConfig = {
  sessionLimit: 100,
  playlistLimit: 50,
}

export default playlistsConfig
